module.exports = __webpack_public_path__ + "assets/77f8ed6258b3c0ec330e854ae274dec3.png";